import React from 'react';

const About = () => {



    return (
        <div>test About</div>
    )
}

export default About